import { Stack } from '@mui/material';

import { useRequiredParam } from '@/hooks/useRequiredParam';
import { MemosTab } from '@/modules/memos/MemosTab/MemosTab';

export function ClientDetailsMemosPage() {
  const householdId = useRequiredParam('householdId');

  return (
    <Stack spacing={2} direction="row" width="100%" flex={1} minHeight={0}>
      <Stack spacing={2} display="flex" flex={1} minWidth={0} minHeight={0}>
        <MemosTab householdId={householdId} />
      </Stack>
    </Stack>
  );
}
